type basicTemplateParams = {
  title: string;
  content: string; 
  companyName: string;
};

export const basicEmailTemplate = ({
  title,
  content,
  companyName
}: basicTemplateParams): string => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8" />
      <title>${title}</title>
    </head>
    <body style="margin:0; padding:0; background-color:#f4f4f4; font-family:Arial, Helvetica, sans-serif;">

      <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f4; padding:20px 0;">
        <tr>
          <td align="center">

            <table width="600" cellpadding="0" cellspacing="0"
              style="background-color:#ffffff; border-radius:6px; overflow:hidden;">

              <!-- Header -->
              <tr>
                <td style="background-color:#2f80ed; padding:20px; text-align:center;">
                  <h1 style="margin:0; color:#ffffff; font-size:22px;">
                    ${title}
                  </h1>
                </td>
              </tr>

              <!-- Content -->
              <tr>
                <td style="padding:30px; color:#333333; font-size:14px; line-height:1.6;">
                  ${content}
                </td>
              </tr>

              <!-- Footer -->
              <tr>
                <td style="background-color:#f0f0f0; padding:15px; text-align:center;
                          font-size:12px; color:#777777;">
                  © ${new Date().getFullYear()} ${companyName}. All rights reserved.
                </td>
              </tr>

            </table>

          </td>
        </tr>
      </table>

    </body>
    </html>
  `;
};

export const basicEmailContent = (
  name: string,
  formName: string,
  companyName: string,
): string => {
  return `
      <p>Dear <strong>${name}</strong>,</p>
      <p>
        Please find your ${formName} attached with this email.
      </p>
      <p>
        If you have any questions, feel free to contact us.
      </p>
      <p>
        Regards,<br/>
        <strong>${companyName}</strong>
      </p>
    `
};


export const Emailer = {
  Basic:{
    Attach: basicEmailTemplate,
    Content: basicEmailContent,
  }
}